<template>
  <div :class="{selected: selected}">
    {{value}}
  </div>
</template>

<script>
export default {
  name: 'select-cell-renderer',

  data () {
    return {
      value: null,
      selected: null
    }
  },

  mounted () {
    this.value = this.params?.value.text
    this.selected = this.params?.value.selected
  }
}
</script>

<style scoped>

</style>
